import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Img } from "../../../sharedComponents/Images";
import { Icon } from "../../Icons";
import * as styles from "./Profile.module.scss";

const Profile = ({ name, role, image, isActive, setKey, imageSrcSet, activeMember, id }) => {
	const handleToggle = () => {
		if (activeMember === id) setKey(null);
		else setKey(id);
	};

	return (
		<div
			role="button"
			tabIndex={0}
			className={cx(styles.profile, {
				[styles.active]: isActive,
			})}
			onClick={handleToggle}
			onKeyDown={handleToggle}
			data-testid="infoPanel-profile-view">
			<div className={styles.profile__picture}>
				<Img
					src={image.src}
					fluid={image.fluid}
					source={imageSrcSet}
					alt={`${name}: ${role}`}
					wrapperClassName={styles.profile__imgWrapper}
				/>
				{isActive ? (
					<Icon name="minus" className={`swg-text-lg ${styles.btn} ${styles.btnActive}`} />
				) : (
					<Icon name="plus" className={`swg-text-lg ${styles.btn}`} />
				)}
			</div>
			<div className={styles.profile__info}>
				<strong>{name}</strong>
				{role}
			</div>
		</div>
	);
};

Profile.propTypes = {
	name: PropTypes.string.isRequired,
	role: PropTypes.string.isRequired,
	isActive: PropTypes.bool,
	image: PropTypes.shape({
		alt: PropTypes.string,
		cloudinary: PropTypes.shape({
			adoptHeight: PropTypes.bool,
			aspectRatio: PropTypes.number,
			height: PropTypes.number,
			publicId: PropTypes.string,
			rawTransformation: PropTypes.string,
			version: PropTypes.number,
			width: PropTypes.number,
		}),
		fluid: PropTypes.shape({
			aspectRatio: PropTypes.number,
			sizes: PropTypes.string,
			src: PropTypes.string,
			srcSet: PropTypes.string,
		}),
		src: PropTypes.string,
		title: PropTypes.string,
	}).isRequired,
	setKey: PropTypes.func.isRequired,
	imageSrcSet: PropTypes.shape({
		src: "",
		srcSet: "",
		size: "",
	}),
	activeMember: PropTypes.any.isRequired,
	id: PropTypes.string.isRequired,
};
Profile.defaultProps = {
	isActive: null,
	imageSrcSet: null,
};

export default Profile;
export { Profile };
